import type { TOC } from '@ember/component/template-only'
import { on } from '@ember/modifier'
import { and } from 'ember-truth-helpers'

export interface BannerSignature {
  Args: {
    title?: string
    message?: string
    actionLabel?: string
    onAction?: () => void
  }
  Element: HTMLDivElement
}

/**
 * A full-width strip for a page-level notice, with an optional action on the right.
 *
 * @param title - Bold lead-in text
 * @param message - Text shown after the title
 * @param actionLabel - Label for the action button. The button only renders when both this and `onAction` are set
 * @param onAction - Called when the action button is clicked
 */
const Banner: TOC<BannerSignature> = <template>
  <div
    data-testid='ui-kit__banner'
    class='bg-[#FCF3E4] text-[#B75E1B] flex w-full items-center justify-between gap-4 px-4 py-2 text-reg-para-14'
    ...attributes
  >
    <span>
      {{#if @title}}
        <span data-testid='ui-kit__banner__title' class='text-component-bold-para-14'>{{@title}}</span>
      {{/if}}
      {{@message}}
    </span>
    {{#if (and @actionLabel @onAction)}}
      <button
        type='button'
        {{on 'click' @onAction}}
        data-testid='ui-kit__banner__action'
        class='text-component-bold-para-14 shrink-0 cursor-pointer underline-offset-2 hover:underline'
      >
        {{@actionLabel}}
      </button>
    {{/if}}
  </div>
</template>

export default Banner
